import { useSpacesContext } from "@circle-react/contexts/spacesContext";

import { isImagesSpace } from "@/react/helpers/spaceHelpers";
import { posts } from "@/react/helpers/urlHelpers/posts";
import { usePostModalBackgroundPathname } from "@/react/hooks/usePostModalNavigation";
import { usePostModalParams } from "@/react/hooks/usePostModalParams";

const normalizePath = (path: string) => path.replace(/\/$/, "");

export const useShouldRenderImagePostDetailsModal = () => {
  const { spaceSlug } = usePostModalParams();
  const backgroundPathname = usePostModalBackgroundPathname();
  const spacesContext = useSpacesContext();
  const space = spacesContext.helpers.findBy({ slug: spaceSlug });

  if (!spaceSlug || !backgroundPathname || !isImagesSpace(space)) return false;

  return (
    normalizePath(backgroundPathname) ===
    normalizePath(posts.index({ spaceSlug }))
  );
};
